import Swiper from 'swiper'
import {
  Navigation,
  Pagination,
  Keyboard,
  Scrollbar,
  Controller,
  Mousewheel,
  EffectCreative,
} from 'swiper/modules'
import 'swiper/css'

Swiper.use([Navigation, Pagination, Keyboard, Scrollbar, Controller, Mousewheel, EffectCreative])
window.Swiper = Swiper
